module.exports = "build/assets/RingsideRegular-Light.24c4379a.woff";